import { InlineLink } from "./InlineLink";

export const ContentItemPreviewLearnMore = () => <InlineLink href="https://authory.com/help/en/articles/9667500-how-does-the-preview-of-content-items-work" target="_blank">Learn more</InlineLink>;